export const issuesMockData = {
	1: [
		{
			issueId: 10412,
			issueType: {
				issueTypeId: '10004',
				name: 'Story',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
				},
			},
			issueKey: 'KAN-363',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-05T08:34:03.07Z',
		},
		{
			issueId: 10411,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'KAN-362',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
		{
			issueId: 10410,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-361',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10408,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-359',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10409,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-360',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10398,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-353',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10352,
			issueType: {
				issueTypeId: '10004',
				name: 'Story',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
				},
			},
			issueKey: 'KAN-397',
			summary: 'Dummy Issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-05T08:34:03.07Z',
		},
		{
			issueId: 10007,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'SE-2',
			summary: 'testing',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
		{
			issueId: 10008,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'test summary',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10009,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'test summary',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10010,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'dummy issues',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10011,
			issueType: {
				issueTypeId: '10004',
				name: 'Story',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
				},
			},
			issueKey: 'SS-1',
			summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-05T08:34:03.07Z',
		},
		{
			issueId: 10012,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'SE-2',
			summary: 'testing',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
		{
			issueId: 10013,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'SE-2',
			summary: 'testing',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
		{
			issueId: 10014,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'test summary',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10015,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'dummy issues',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10016,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'test summary',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10017,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-4',
			summary: 'dummy issues',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10018,
			issueType: {
				issueTypeId: '10004',
				name: 'Story',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
				},
			},
			issueKey: 'SS-1',
			summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-05T08:34:03.07Z',
		},
		{
			issueId: 10019,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'SE-2',
			summary: 'testing',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
	],
	2: [
		{
			issueId: 10407,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-358',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10406,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-357',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10404,
			issueType: {
				issueTypeId: '10005',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-355',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-09-19T08:34:03.07Z',
		},
		{
			issueId: 10399,
			issueType: {
				issueTypeId: '10008',
				name: 'Task',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
				},
			},
			issueKey: 'KAN-354',
			summary: 'This is a archived issue',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-02T08:34:03.07Z',
		},
		{
			issueId: 10024,
			issueType: {
				issueTypeId: '10004',
				name: 'Story',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10300?size=medium',
				},
			},
			issueKey: 'SS-1',
			summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-03-05T08:34:03.07Z',
		},
		{
			issueId: 10025,
			issueType: {
				issueTypeId: '10006',
				name: 'Epic',
				avatar: {
					medium:
						'https://rkumar8.jira-dev.com/rest/api/2/universal_avatar/view/type/issuetype/avatar/10307?size=medium',
				},
			},
			issueKey: 'SE-2',
			summary: 'testing',
			archivedBy: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl: '',
					name: 'Unassigned',
					__typename: 'AtlassianAccountUser',
				},
			},
			reporter: {
				user: {
					id: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountId: '712020:e0fdedd5-a4cf-46c1-aef2-246fe1c7a0a7',
					accountStatus: 'active',
					avatarUrl:
						'https://secure.gravatar.com/avatar/865d977f196c2fcae342b4c1a61633cb?d=https%3A%2F%2Favatar-management--avatars.us-west-2.staging.public.atl-paas.net%2Finitials%2FRK-6.png',
					name: 'Rohit Kumar',
					__typename: 'AtlassianAccountUser',
				},
			},
			archivedDate: '2024-04-24T08:34:03.07Z',
		},
	],
};
